import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useStore } from '@/store'
import { useBreakpoint } from 'vuestic-ui/web-components'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { routeTitle: "Z-Tune" /**"Solfegio Exercise Generator"*/ },
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/intervals',
    name: 'intervals',
    meta: {
      routeTitle: 'فواصل گسسته',
      title: ' title: '
    },

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Intervals" */ '../views/Intervals.vue')
  },
  {
    meta: {
      routeTitle: "Simple Scale",
      description: 'تمرین گام',
      persianTitle: 'گام'
    },
    path: '/simple-scale',
    name: 'simple-scale',
    component: () => import(/* webpackChunkName: "SimpleScale" */ '../views/SimpleScale.vue')
  },
  {
    meta: {
      routeTitle: "Continuous Intervals",
      persianTitle: 'فوصل پیوسته',
      description: 'تمرین فواصل پیوسته',
    },
    path: '/continuous-intervals',
    name: 'continuous-intervals',
    component: () => import(/* webpackChunkName: "ContinuousIntervals" */ '../views/ContinuousIntervals.vue')
  },
  {
    meta: {
      routeTitle: "Discrete Intervals",
      persianTitle: 'فواصل گسسته',
      description: 'تمرین گام',
    },
    path: '/discrete-intervals',
    name: 'discrete-intervals',
    component: () => import(/* webpackChunkName: "DiscreteIntervals" */ '../views/DiscreteIntervals.vue')
  },
  {
    meta: {
      routeTitle: "Arpeggio",
      persianTitle: 'آرپژ',
      description: 'تمرین آرپژ',
    },
    path: '/arpeggio',
    name: 'arpeggio',
    component: () => import(/* webpackChunkName: "Arpeggio" */ '../views/Arpeggio.vue')
  },
  {
    meta: {
      routeTitle: "About",
      persianTitle: 'درباره اپ',
      description: 'اپ تمرینات سلفژ رضا سیدی',
    },
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "Arpeggio" */ '../views/AboutView.vue')
  },
  {
    meta: {
      routeTitle: "Rhythm",
      persianTitle: 'وزن‌خوانی',
      description: 'تمرین وزن‌خوانی',
    },
    path: '/rhythm',
    name: 'rhythm',
    component: () => import(/* webpackChunkName: "rhythm" */ '../views/rhythm/Index.vue')
  },
  {
    meta: {
      routeTitle: "Rhythm Detector",
      persianTitle: 'تصحیح تمرین وزن‌خوانی',
      description: 'با هر تمپویی که خواستید، الگوهای ریتمیک مورد نظرتان را روی آیکون ضربه بزنید.',
    },
    path: '/rhythm/detector',
    name: 'rhythm/detector',
    component: () => import(/* webpackChunkName: "rhythm" */ '../views/rhythm/Detector.vue')
  },
  {
    meta: {
      routeTitle: "Ear Training",
      persianTitle: 'تربیت شنوایی',
      description: 'تشخیص فواصل',
    },
    path: '/ear-training',
    name: 'earTraining',
    component: () => import(/* webpackChunkName: "rhythm" */ '../views/EarTraining/index.vue')
  },
  {
    path: '/ideas',
    name: 'ideas',
    children: [
      { path: 'midi-test', component: () => import('@/views/ideas/MidiTest.vue') }
    ]
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/Test.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(guard => {
  if (guard.query.debug == "true") useStore().state.debug.isDevEnv = true;
  // if (typeof guard.meta.routeTitle == 'string') document.title = guard.meta.routeTitle +( guard.meta.persianTitle ?  ' | '+ guard.meta.persianTitle : '')
})


router.afterEach((to) => {
  if (window.innerWidth < 768) useStore().state.ui.showSidebar = false


  if (typeof to.meta.routeTitle == 'string') document.title = to.meta.routeTitle + (to.meta.persianTitle ? ' | ' + to.meta.persianTitle : '')

  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription && to.meta?.description) {
    metaDescription.setAttribute('content', to.meta.description as string)
  }
  return true
})
export default router
